import React from 'react'
import LancamentoPagamentosListPageContainer from './LancamentoPagamentosListPageContainer'

export class LancamentoPagamentosListPage extends React.Component {
  render() {
    return <LancamentoPagamentosListPageContainer {...this.props} />
  }
}
